<div class="error-dialog">
  <h6>{{data.title | translate}}</h6>
  <p>{{data.message | translate}}</p>
  <button mat-button class="normal-button" [ngStyle]="{'background-color': this.proColor}" (click)="closeDialog()">{{'CLOSE' | translate}}</button>
</div>
